import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawPauseIcon from "./RawPauseIcon.svg.jsx";

const PauseIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawPauseIcon} {...props} />;
});

export default PauseIcon;
